import React from 'react';
import { graphql, gql, compose } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { Table, Input, Modal, Checkbox, Icon, DatePicker, Tooltip, Button, Select, message, Row, Col } from 'antd';



const { TextArea } = Input;


class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            advisoryUpdate: '',
        };

        this.handleChangeAdvisoryContact = this.handleChangeAdvisoryContact.bind(this);
    }
    handleChangeAdvisoryContact(value) {
        console.log("handleChangeAdvisoryContact", value)
        this.setState({ advisoryUpdate: value.target.value });
    }
    updateAdvisory(row) {
        this.props.updateContact({
            variables: {
                _id: row._id,
                name: row._name,
                email: row.email,
                advisory: this.state.advisoryUpdate
            }
        }).then((data) => {
            message.success("Done", 2);
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        })
    }
    renderContactListCurr() {
        console.log("ad", this.props);
        if (this.props.loading === true)
            return <p>Loading</p>
        const columns = [
            {
                title: 'Stt',
                key: 'stt',
                render: (text, row, index) => {
                    return index + 1
                },
            },

            {
                title: 'Họ tên',
                dataIndex: 'name',
                key: 'name',

            },
            { title: 'SĐT', dataIndex: 'phone', key: 'phone' },
            { title: 'Mail', dataIndex: 'email', width: 140, key: 'email' },
            { title: 'Nghề nghiệp', dataIndex: 'career', width: 110, key: 'job' },

            {
                title: 'Logo',
                key: 'logo',
                width: 250,
                render: (text, row) => (

                    <div>
                        {
                            row.linkLogo.map((element,index) => {
                                console.log(element);
                                return <a href={element} target="blank"><img src={element} style={{width:60}} /></a>
                               
                            })
                        }
                    </div>
                ),
            },
            {
                title: 'Ngày đăng ký',
                key: 'createdAt',
                dataIndex: 'createdAt',
                render: (text, row, index) => {
                    return text ? (new Date(text)).toLocaleString() : ""
                }
            },
            {
                title: 'Nguồn',
                key: 'source',
                dataIndex: 'source',
               
            },
            
            {
                title: 'Tư vấn',
                key: 'note',
                width: 250,
                render: (text, row) => (
                    <div>
                        <p style={{textAlign:"justify",wordBreak:"break-word"}}>{row.advisory}</p>
                        <TextArea style={{ width: 250, height: 90 }} className="" placeholder="Nhận xét" onChange={this.handleChangeAdvisoryContact} />
                    </div>
                ),
            },
            {
                title: 'Update',
                key: 'update',
                render: (text, row) => (
                    sessionStorage.getItem('role')==="admin"?
                    <div>
                        <Button type="primary" onClick={this.updateAdvisory.bind(this, row)}>Gửi Mail Nhận Xét</Button>
                    </div>:""
                ),
            },


        ];

        return (

            <div className="staff-contact-table">
                <Table
                    columns={columns}
                    rowKey={row => row._id}
                    dataSource={this.props.getCtsAll.getCtsAll}
                    pagination={{ pageSize: 10 }}
                    title={() => (<h1 style={{ textAlign: 'center' }}>Danh sách cts </h1>)}
                />
            </div>
        );
    }

    render() {

        return (
            <div className="staff-contact-list">
                {/* <StatisticCurr /> */}

                {
                    this.renderContactListCurr()
                }
            </div>
        )
    }
}

const updateContact = gql`
mutation updateContact($_id: String,$name:String,$email:String,$advisory:String){
    updateContact(_id:$_id, name:$name,email:$email,advisory:$advisory){
        _id
    }
}
`
const getCtsAll = gql`
query getCtsAll{
  getCtsAll{
    _id,name,phone,career,email,createdAt,linkLogo,source,advisory
  }
}
`
export default compose(
    graphql(getCtsAll, { name: "getCtsAll" }),
    graphql(updateContact, { name: "updateContact" }),
)(withRouter(App));



// WEBPACK FOOTER //
// ./src/components/Staff/ContactListStaff.js